import HeadData from 'components/Common/HeadData'
import React from 'react'
import { useIntl } from 'react-intl'

function CruiseDestinationsHeadData(props: { destination: string }) {
  const intl = useIntl()
  const { destination } = props
  const currentYear = new Date().getFullYear()
  const title = intl.formatMessage(
    {
      id: 'LerQp4CuU/',
      defaultMessage: 'Cruises to {destination} | Best Deals {currentYear} - {nextYear}',
      description: 'SEO page title for cruise destination landing page',
    },
    { destination, currentYear, nextYear: currentYear + 1 },
  )
  const description = intl.formatMessage(
    {
      id: '5Un/rB1A1A',
      defaultMessage: 'Embark on a cruise to {destination} with Luxury Escapes. Browse our wide variety of exclusive deals and curated extras to make your cruise unforgettable.',
      description: 'SEO meta description for cruise destination landing page',
    },
    { destination },
  )

  return <HeadData title={title} description={description} />
}

export default CruiseDestinationsHeadData
